import { useTranslation } from "react-i18next";
import { Frame, Note } from "../shared";
import type { WidgetProps } from "../types";

/** A catalogue widget type this version of the web app does not draw yet (the charts and the map come in M4). */
export function NotYet({ widget }: WidgetProps) {
  const { t } = useTranslation();
  return (
    <Frame widget={widget} state="placeholder" title={widget.title}>
      <Note>{t("widgets.notYet")}</Note>
    </Frame>
  );
}
